<template>
  <section>
    <div class="px-3 py-6 md:px-6 md:py-6" v-show="!placeholder">
      <div class="pb-6">
        <h2 class="text-ontick-steel-900 text-3xl font-semibold dark:text-gray-300">Meus dados</h2>
        <p class="text-ontick-steel-900 text-sm dark:text-gray-300">
          Acompanhe as cobranças de seus produtos e estratégias contratadas.
        </p>
      </div>

      <div class="bg-ontick-steel-100 dark:bg-ontick-graphite-500 mb-6 max-w-xl rounded-lg px-6 py-6">
        <div class="flex space-x-6">
          <div class="self-center">
            <v-gravatar :size="60" :hash="user_picture" />
          </div>
          <h1 class="text-ontick-carbon-900 text-lg font-medium dark:text-gray-300 sm:text-2xl">
            {{ user.name }}
          </h1>
        </div>
      </div>
      <form class="grid grid-cols-12 gap-3" @submit.prevent="update()">
        <!-- Nome Completo -->
        <ontick-input
          placeholder="Nome Completo"
          v-model="user.name"
          label="Nome Completo"
          name="name"
          type="text"
          :disabled="false"
          :error="errors.first('name')"
          bg="dark:bg-ontick-graphite-500 bg-ontick-steel-100"
          class="col-span-full md:col-span-5 lg:col-span-6 xl:col-span-4"
          noBorder
        ></ontick-input>

        <ontick-input
          placeholder="Data de Nascimento"
          v-model="user.birthday"
          label="Nascimento"
          name="birthday"
          v-mask="date"
          :error="errors.first('birthday')"
          bg="dark:bg-ontick-graphite-500 bg-ontick-steel-100"
          class="col-span-6 md:col-span-3 lg:col-span-3 xl:col-span-4"
          noBorder
        ></ontick-input>

        <div class="col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-4">
          <p class="text-ontick-carbon-900 mb-1 text-xs dark:text-gray-300" for="">Gênero</p>

          <select
            class="border-ontick-steel-300 bg-ontick-steel-100 text-ontick-carbon-900 dark:border-ontick-graphite-500 dark:bg-ontick-graphite-500 w-full appearance-none rounded-lg border shadow-lg focus:outline-none dark:text-gray-300 sm:text-sm"
            v-model="user.gender"
          >
            <option
              class="bg-ontick-steel-100 text-ontick-steel-900 dark:bg-ontick-steel-500 dark:text-gray-300"
              value
              disabled
              selected
            >
              Gênero
            </option>

            <option value="M" class="bg-ontick-container text-light">Masculino</option>
            <option value="F" class="bg-ontick-container text-light">Feminino</option>
            <option value="O" class="bg-ontick-container text-light">Outros</option>
          </select>
        </div>

        <div class="relative col-span-full md:col-span-5 lg:col-span-6 xl:col-span-4">
          <ontick-input
            placeholder="E-mail"
            v-model="user.email"
            label="E-mail"
            name="email"
            :disabled="true"
            type="text"
            :error="errors.first('email')"
            bg="dark:bg-ontick-steel-500 bg-ontick-steel-200"
            noBorder
          >
          </ontick-input>
          <div class="absolute bottom-3 right-3" v-html="$icons.lock"></div>
        </div>

        <div class="relative col-span-full md:col-span-3 lg:col-span-6 xl:col-span-4">
          <ontick-input
            v-if="user.cpf"
            placeholder="CPF"
            v-model="user.cpf"
            label="CPF"
            :disabled="true"
            name="cpf"
            type="text"
            :error="errors.first('cpf')"
            bg="dark:bg-ontick-steel-500 bg-ontick-steel-200"
            v-mask="mask_cpf"
            noBorder
          ></ontick-input>
          <ontick-input
            v-else-if="user.cnpj"
            placeholder="CNPJ"
            v-model="user.cnpj"
            label="CNPJ"
            :disabled="true"
            name="cnpj"
            type="text"
            :error="errors.first('cnpj')"
            bg="dark:bg-ontick-steel-500 bg-ontick-steel-200"
            v-mask="mask_cnpj"
            noBorder
          ></ontick-input>
          <div class="absolute bottom-3 right-3" v-html="$icons.lock"></div>
        </div>

        <div class="relative col-span-full md:col-span-4 lg:col-span-4 xl:col-span-4">
          <ontick-input
            placeholder="Telefone"
            v-model="user.phone"
            label="Telefone"
            name="phone"
            :disabled="true"
            type="text"
            :error="errors.first('phone')"
            bg="dark:bg-ontick-steel-500 bg-ontick-steel-200"
            noBorder
          ></ontick-input>
          <div class="absolute bottom-3 right-3" v-html="$icons.lock"></div>
        </div>
        <!-- País -->
        <ontick-select-component
          class="col-span-6 md:col-span-3 lg:col-span-4 xl:col-span-3"
          bg="dark:bg-ontick-graphite-500 bg-ontick-steel-100"
          label="País"
          :options="countries"
          name="country"
          v-model="user.address.country"
        />
        <!-- /País -->

        <!-- CEP -->
        <ontick-input
          placeholder="CEP"
          v-model="user.address.zipCode"
          label="CEP"
          name="zipCode"
          type="text"
          :error="errors.first('zipCode')"
          bg="dark:bg-ontick-graphite-500 bg-ontick-steel-100"
          @keyup.native="getCep(user.address.zipCode)"
          v-mask="mask_cep"
          class="col-span-6 md:col-span-4 lg:col-span-4 xl:col-span-3"
          noBorder
        ></ontick-input>
        <!-- /CEP -->

        <!-- Endereço -->
        <ontick-input
          placeholder="Endereço"
          v-model="user.address.address"
          label="Endereço"
          name="address"
          type="text"
          :error="errors.first('address')"
          bg="dark:bg-ontick-graphite-500 bg-ontick-steel-100"
          class="col-span-full md:col-span-5 lg:col-span-6 xl:col-span-4"
          noBorder
        ></ontick-input>
        <!-- /Endereço -->

        <!-- Número -->
        <ontick-input
          placeholder="Número"
          v-model="user.address.number"
          label="Número"
          name="number"
          type="text"
          :error="errors.first('number')"
          bg="dark:bg-ontick-graphite-500 bg-ontick-steel-100"
          class="col-span-6 md:col-span-3 lg:col-span-6 xl:col-span-2"
          noBorder
        ></ontick-input>
        <!-- /Número -->

        <!-- Complemento -->
        <ontick-input
          placeholder="Complemento"
          v-model="user.address.complement"
          label="Complemento"
          name="complement"
          type="text"
          :error="errors.first('complement')"
          bg="dark:bg-ontick-graphite-500 bg-ontick-steel-100"
          class="col-span-6 md:col-span-4 lg:col-span-6 xl:col-span-3"
          noBorder
        ></ontick-input>
        <!-- /Complemento -->

        <!-- Bairro -->
        <ontick-input
          placeholder="Bairro"
          v-model="user.address.neighborhood"
          label="Bairro"
          name="neighborhood"
          type="text"
          :error="errors.first('neighborhood')"
          bg="dark:bg-ontick-graphite-500 bg-ontick-steel-100"
          class="col-span-6 md:col-span-5 lg:col-span-6 xl:col-span-3"
          noBorder
        ></ontick-input>
        <!-- /Bairro -->

        <!-- Cidade -->
        <ontick-input
          placeholder="Cidade"
          v-model="user.address.city"
          label="Cidade"
          name="city"
          type="text"
          :error="errors.first('city')"
          bg="dark:bg-ontick-graphite-500 bg-ontick-steel-100"
          class="col-span-6 md:col-span-3 lg:col-span-6 xl:col-span-4"
          noBorder
        ></ontick-input>
        <!-- /Cidade -->

        <!-- Estado -->
        <ontick-input
          placeholder="Ex. SP"
          v-model="user.address.state"
          label="Estado"
          name="state"
          type="text"
          v-mask="'AA'"
          :error="errors.first('state')"
          bg="dark:bg-ontick-graphite-500 bg-ontick-steel-100"
          class="col-span-6 md:col-span-4 lg:col-span-6 xl:col-span-2"
          noBorder
        ></ontick-input>
        <!-- /Estado -->

        <ontick-div class="col-span-12 flex justify-end pt-6">
          <ontick-button color="primary" type="submit">
            <svg
              class="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              ></path>
            </svg>
            <span class="ml-2">Atualizar dados</span>
          </ontick-button>
        </ontick-div>
      </form>
      <!-- ************************************************************************************** -->
    </div>
    <placeholderTable class="px-6 py-6" v-show="placeholder" />
  </section>
</template>

<script>
import { mapState } from "vuex";
import filter from "@/app/shared/filters/filter.js";
import placeholderTable from "@/app/shared/components/placeholder/placeholder-table.component.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Gravatar from "vue-gravatar";
import OntickSelectComponent from "../../../../shared/components/basic/ontick-select.component.vue";

export default {
  name: "profile",
  mixins: [filter],

  components: {
    vSelect,
    placeholderTable,
    "v-gravatar": Gravatar,
    OntickSelectComponent,
  },

  data() {
    return {
      placeholder: false,
      countries: [],
      optionDefault: {
        label: "Gênero",
      },

      optionsSelect: [
        {
          label: "Masculino",
        },
        {
          label: "Feminino",
        },
        {
          label: "Outros",
        },
      ],
      user: {
        name: null,
        birthday: null,
        gender: null,
        cpf: null,
        cnpj: null,
        email: null,
        phone: null,
        address: {
          country: null,
          zipCode: null,
          address: null,
          number: null,
          complement: null,
          neighborhood: null,
          city: null,
          state: null,
        },
      },
    };
  },

  computed: {
    ...mapState({
      user_name: (state) => state.config.user_name,
      user_picture: (state) => state.config.user_picture,
    }),
  },

  mounted() {
    this.placeholder = true;
    const removeSpace = (val) => {
      if (val === " ") return "";
      return val;
    };
    this.$api.get(this.$endpoint.GET_USER_INFO).then((res) => {
      this.user.name = removeSpace(res.data.user_name);
      this.user.gender = removeSpace(res.data.user_gender);
      this.user.cpf = removeSpace(res.data.user_cpf);
      this.user.cnpj = removeSpace(res.data.user_cnpj);
      // this.user.cnpj = 42165520000102;
      this.user.email = removeSpace(res.data.user_email);
      this.user.phone = removeSpace(res.data.user_phone);
      this.user.address.country = removeSpace(res.data.user_country);
      this.user.address.zipCode = removeSpace(res.data.user_cep);
      this.user.address.address = removeSpace(res.data.user_address);
      this.user.address.number = removeSpace(res.data.user_address_number);
      this.user.address.complement = removeSpace(res.data.user_address_complement);
      this.user.address.neighborhood = removeSpace(res.data.user_neighborhood);
      this.user.address.city = removeSpace(res.data.user_city);
      this.user.address.state = removeSpace(res.data.user_state);
      this.placeholder = false;

      if (res.data.user_birthday) {
        let date_format = res.data.user_birthday.split("-");
        date_format = date_format[2] + "/" + date_format[1] + "/" + date_format[0];
        this.user.birthday = date_format;
      } else {
        this.user.birthday = "";
      }
    });

    this.$api
      .get(this.$endpoint.COUNTRIES_LIST)
      .then((res) => {
        this.countries = res.data.map((item) => {
          return {
            value: item.code,
            label: item.country,
          };
        });
      })
      .catch((error) => {
        // console.log("ERROR", error);
      });
  },
  methods: {
    update() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          let params = new Object();

          if (this.user.name) params.user_name = this.user.name;
          if (this.user.gender) params.user_gender = this.user.gender;

          let date_format;
          if (this.user.birthday) {
            const split = this.user.birthday.split("/");
            date_format = split[2] + "-" + split[1] + "-" + split[0];

            params.user_birthday = date_format;
          }

          params.user_country = this.user.address.country || " ";
          params.user_cep = this.user.address.zipCode || " ";
          params.user_address = this.user.address.address || " ";
          params.user_address_number = this.user.address.number || String(1);
          params.user_address_complement = this.user.address.complement || " ";
          params.user_neighborhood = this.user.address.neighborhood || " ";
          params.user_city = this.user.address.city || " ";
          params.user_state = this.user.address.state || " ";

          this.$api
            .post(this.$endpoint.POST_USER_INFO, params)
            .then(() => {
              this.$swal({
                title: "Dados alterados com sucesso.",
                icon: "success",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 30000,
                timerProgressBar: true,
              });
            })
            .catch((error) => {
              this.$swal({
                title: error.data.error,
                icon: "error",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    getCep(zipCode) {
      if (zipCode.trim() == "" || zipCode.length < 8) {
        return;
      } else {
        if (/^[0-9]{5}-[0-9]{3}$/.test(zipCode)) {
          this.$api
            .get(`https://cep.awesomeapi.com.br/json/${zipCode}`)
            .then((response) => {
              this.user.address.address = response.data.address;
              this.user.address.neighborhood = response.data.district;
              this.user.address.city = response.data.city;
              this.user.address.state = response.data.state;
            })
            .catch((error) => {
              console.error("ERROR", error);
            });
        }
      }
    },
  },
};
</script>

<style lang="scss">
.vs__search {
  @apply bg-ontick-steel-100 text-ontick-carbon-900 dark:bg-ontick-graphite-500 border-0 py-0.5 dark:text-gray-300 #{!important};
}

.vs__selected {
  @apply text-ontick-carbon-900 text-sm dark:text-gray-300;
}
.vs__dropdown-toggle {
  @apply relative;
}
.vs__actions {
  @apply text-ontick-carbon-900 dark:text-gray-300;
}
</style>
